
angular.module('membership')
  .controller('UserDetailsBaseCtrl', [
    '$scope', '$stateParams',
    function($scope, $stateParams) {
      $scope.tab = $stateParams.tab;
      $scope.userId = $stateParams.id;
    }
  ]);